import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawDecodableFilledIcon from "./RawDecodableFilledIcon.svg.jsx";

const DecodableFilledIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawDecodableFilledIcon}
      title="Decodable filled icon"
      {...props}
    />
  );
});

DecodableFilledIcon.displayName = "DecodableFilledIcon";
export default DecodableFilledIcon;
